import React, { useContext } from "react";
import "./CSS/Checkout.css";
import { ShopContext } from "../Context/ShopContext";

const Checkout = () => {
  const { getTotalCartAmount, discountCode } = useContext(ShopContext);

  return (
    <div className="checkout">
      <div className="checkout-container">
        <div className="checkout-left">
          <h2>Billing Details</h2>
          <form className="checkout-form">
            <input type="text" placeholder="First Name" required />
            <input type="text" placeholder="Last Name" required />
            <input type="email" placeholder="Email Address" required />
            <input type="text" placeholder="Street Address" required />
            <input type="text" placeholder="City" required />
            <input type="text" placeholder="Zip Code" required />
          </form>
        </div>
        <div className="checkout-right">
          <h2>Your Order</h2>
          <div className="checkout-summary">
            <div className="checkout-summary-item">
              <p>Subtotal</p>
              <p>₹{getTotalCartAmount()}</p>
            </div>
            <hr />
            <div className="checkout-summary-item">
              <p>Shipping</p>
              <p>Free</p>
            </div>
            <hr />
            {discountCode && discountCode.type !== 'none' && (
              <>
                <div className="checkout-summary-item" style={{color: '#E76F2E', fontWeight: 'bold'}}>
                  <p>Promo Active:</p>
                  <p>{discountCode.label}</p>
                </div>
                <hr />
              </>
            )}
            <div className="checkout-summary-item checkout-total">
              <p>Total</p>
              <p>₹{getTotalCartAmount()}</p>
            </div>
          </div>
          <button className="place-order-btn" onClick={() => alert("Order Placed Successfully!")}>
            PLACE ORDER
          </button>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
